module.exports = __webpack_public_path__ + "static/media/中巴地球资源卫星01星.08b0980f.png";